import http from "./httpService";
import config from "../config.json";

const apiEndpoint = config.apiEndpoint + "/leagues";

export async function getLeagues() {
  const response = await http.get(apiEndpoint);
  return response.data;
}

export async function getLeague(id) {
  const response = await http.get(apiEndpoint + "/" + id);
  return response.data;
}

export async function saveLeague(league) {
  let leagueInDb = league || {};
  leagueInDb.name = league.name;

  if (leagueInDb.id === -1) await http.post(apiEndpoint, leagueInDb);
  else await http.put(apiEndpoint + "/" + leagueInDb.id, leagueInDb);

  return leagueInDb;
}

export async function deleteLeague(id) {
  await http.delete(apiEndpoint + "/" + id);
}



// WEBPACK FOOTER //
// ./src/services/leagueService.js